module.exports = __webpack_public_path__ + "35f250350349785f9a9520c158beb4fd.png";